'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoEnvioCtrl', function ($scope, $stateParams, $window) {
        // classe para animação da view
        $scope.pageClass = 'page-envio';
        $scope.pedido = {};

        var pedido = $stateParams.pedido;
        if (pedido) {
            $scope.pedido = pedido;
        }

        $scope.dataHoraACaminhoMandae = function () {
            return $scope.pedido.dataHoraACaminhoMandae != null ? new Date($scope.pedido.dataHoraACaminhoMandae) : '';
        }

        $scope.abrirLinkFatura = function () {
            $window.open($scope.pedido.fatura.url, '_blank');
        }

        $scope.exibeLinkFatura = function () {
            return $scope.pedido.fatura &&
                $scope.pedido.fatura.codigoSituacao == 'NaoPaga' &&
                $scope.pedido.fatura.url;
        }

    });
